import { AxiosResponse } from 'axios';

import axiosInstance from 'api/base';

import { normalizeHFMerchant, normalizeHFTheme } from './normalizers';
import {
  IActivateHFThemePayload,
  IActiveHFTheme,
  ICreateHFThemePayload,
  IDeleteHFThemePayload,
  IHostedFieldsMerchant,
  IHostedFieldsTheme,
  IUpdateHFThemePayload,
  TStoredHFTheme,
} from './types';

const serializeThemeData = ({
  layoutName,
  palette,
  permanentPalette,
  theme,
}: TStoredHFTheme) => JSON.stringify({ layoutName, palette, permanentPalette, theme });

const hostedFieldsThemesAPI = {
  async createTheme({ id, theme }: ICreateHFThemePayload): Promise<IHostedFieldsTheme> {
    const { data } = await axiosInstance.post(
      `customizations/merchants/terminals/${id}/hosted-fields-themes`,
      // `merchant-terminals/${id}/hosted-fields-themes`, // for local tests only
      {
        name: theme.name,
        preview: theme.preview,
        theme: serializeThemeData(theme),
      },
    );

    return normalizeHFTheme(data);
  },

  async deleteTheme({ id, themeId }: IDeleteHFThemePayload): Promise<IActiveHFTheme> {
    const result = await axiosInstance.delete(
      `customizations/merchants/terminals/${id}/hosted-fields-themes/${themeId}`,
      // `merchant-terminals/${id}/hosted-fields-themes/${themeId}`,   // for local tests only
    );
    return {
      activeHostedFieldsTheme: (result.data?.activeHostedFieldsTheme as string) || '',
    };
  },

  async getThemes(id: string): Promise<IHostedFieldsMerchant> {
    const result = await axiosInstance.get(
      `customizations/merchants/terminals/${id}/hosted-fields-themes`,
      // `merchant-terminals/${id}/hosted-fields-themes`, // for local tests only
    );

    return normalizeHFMerchant(result.data);
  },

  async setActiveTheme({ id, themeId }: IActivateHFThemePayload): Promise<AxiosResponse> {
    const result = await axiosInstance.put(
      `customizations/merchants/terminals/${id}/hosted-fields-themes`,
      // `merchant-terminals/${id}/hosted-fields-themes`, // for local tests only
      { themeId },
      { params: { active: true } },
    );

    return result.data;
  },

  async updateTheme({ id, theme }: IUpdateHFThemePayload): Promise<IHostedFieldsTheme> {
    const { data } = await axiosInstance.put(
      `customizations/merchants/terminals/${id}/hosted-fields-themes/${theme.id}`,
      // `merchant-terminals/${id}/hosted-fields-themes/${theme.id}`, // for local tests only
      {
        name: theme.name,
        preview: theme.preview,
        theme: serializeThemeData(theme),
      },
    );

    return normalizeHFTheme(data);
  },
};

export default hostedFieldsThemesAPI;
